<template>
  <div class="login-container">
    <div class="card">
      <div class="form-item">
        <span>Username</span>
        <v-input
          v-model="username"
          @keyEnter="requestLogin"/>
      </div>
      <div class="form-item">
        <span>Password</span>
        <v-input
          v-model="password"
          type="password"
          @keyEnter="requestLogin" />
      </div>
      <v-button
        type="success"
        @click="requestLogin">Login</v-button>
    </div>
  </div>
</template>
<script>
import {login} from '@/api'
import {mapActions} from 'vuex'

export default {
  name: 'login',
  data() {
    return {
      // 2991349941@qq.com
      username: '',
      password: ''
      // 12345678
    }
  },
  mounted(){
    const token = localStorage.getItem('token')
    if(!token){
      localStorage.removeItem('isVerified')
    }
  },
  methods: {
    ...mapActions('verify',['setIsReset','setIsVerify']),
    requestLogin() {
      this.network().login()
    },
    network() {
      return {
        login: async () => {
          const { data } = await login({
            username: this.username,
            password: this.password
          })
          localStorage.setItem('token', data.access_token)
          localStorage.setItem('refresh_token', data.refresh_token)
          localStorage.setItem('auth', JSON.stringify(data))
          localStorage.setItem('cs_name', data.name)
          let params = ''
          Object.keys(this.$route.query).map(item => {
            if(item != 'fullPath'){
              params += `&${item}=${this.$route.query[item]}`
            }
          })
          let _path = this.$route.query.fullPath? this.$route.query.fullPath : ''
          let fullPath = _path + params
          let {is_second_verified,is_first_reset_password} = data
          this.setIsVerify(!!is_second_verified)
          if(!is_first_reset_password){
            return  this.$router.push(
              {
                path: '/reset/password',
                query: {
                  fullPath
                }
              }
            )
          }
          if(is_first_reset_password){
            this.$router.push({
              path: '/reset/verify',
              query: {
                fullPath
              }
            })
          }
          // else{
          //   const { fullPath = '' } = this.$route.query
          //   if(fullPath) {
          //     this.$router.replace(fullPath)
          //   } else {
          //     this.$router.replace('/')
          //   }
          // }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #fff;
  .card {
    padding: 100px 0;
    width: 500px;
    text-align: center;
    box-shadow:none;
    .form-item {
      margin: 0 auto;
      width: 500px;
      & > span {
        text-align: left;
      }
    }
    .el-button{
      width: 100%;
      margin-top: 20px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      //display: flex;
      //align-items: center;
      letter-spacing: -0.15px;
      color: #FFFFFF;
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
      &--success:hover {
        background: #2EA44F;
        opacity: 0.8;
        border-color: rgba(27, 31, 35, 0.15);
      }
    }
  }
}
</style>
